<template lang="pug">
  div.body.body-table.bank-books-normatives
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
        :options="selectListOptions"
        v-model="operationType"
        )

        // for disabe edit
        //div(v-if="!disabled").toolbar.toolbar--modal
        div.toolbar.toolbar--modal
          div.line
            div.parameters
            div.actions-panel
              e-button-add(
              @click="addNewRow()")

      div(:class="{'is-invalid': getError}")
        e-table-editable(
        ref="editTable"
        :afterFetchData="afterFetchData"
        :tableInOnlineMode="false"
        :attributes="attr"
        :dataUrl="dataEndpoint"
        :postUrl="() => null"
        :patchUrl="() => null"
        :deleteUrl="() => null"
        :tableHeight="'200'"
        :tableHeightRight="'200'"
        :defaultColumnWidth="100"
        )
      div.invalid-relative-container
        transition(v-if="getError" name="fade")
          span( v-show="error").invalid.error {{error}}
</template>

<script>
import { billing } from '@/api/api-endpoints'
import { editableValidatorMixin } from '@/components/table-editable/editable-validator-mixin'

export default {
  name: 'bank-books-normatives',
  mixins: [editableValidatorMixin],
  props: {
    dataUrl: {
      type: Function,
    },
    normativeType: {
      type: String,
    },
    item: {
      type: Object,
    },
    fields: {
      type: Object,
    },
  },
  data() {
    return {
      operationType: null,
      sort: null,
      paginationQuery: null,
    }
  },
  computed: {
    dataEndpoint() {
      return this.dataUrl()
    },
    selectListOptions() {
      return [
        {
          id: 'detail',
          name: 'Категории КУ',
        },
      ]
    },
    attr() {
      return {
        category: {
          label: 'Категория собственности',
          validationRulePattern: '(\\.*)',
          placeholder: 'Начните вводить название',
          required: true,
          width: 150,
          suggestion: {
            options: [],
            onSelect: this.onSelect,
            suggestionEndpoint: this.suggestionEndpoint,
            transformSuggestions: this.transformSuggestions,
          },
        },
        unit: {
          label: 'Расчетная единица',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          disabled: true,
        },
        value: {
          label: 'Кол-во расчетных единиц',
          validationRulePattern: '^(\\d*((\\.\\d{0,3}))?(\\d))$',
          required: true,
        },
        valuePerYear: {
          label: 'Норматив потребления/накопление КУ (куб.м./год на 1 рас.ед.)',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          disabled: true,
        },
        value_month: {
          label: 'Потребление/накопление КУ (куб.м./месяц)',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          disabled: true,
        },
        start_used_at: {
          label:
            'Дата начала действия текущего значения поля <Количество расчетных единиц>',
          placeholder: ' ',
          validationRulePattern: '(\\.*)',
          required: true,
          calendar: {},
        },
      }
    },
  },
  watch: {
    fields: {
      handler: 'onFields',
      deep: true,
    },
  },
  methods: {
    attachWatchers() {
      if (this.$refs.editTable.data) {
        this.$watch(
          () => {
            return this.$refs.editTable.data
          },
          this.onData,
          {
            deep: true,
          }
        )
      } else {
        setTimeout(this.attachWatchers, 50)
      }
    },
    afterFetchData(_, data) {
      data.data.forEach((v) => {
        if (!v.valuePerYear && v.value_month) {
          v.value_month = +v.value_month
          v.valuePerYear = (v.value_month * 12).toFixed(5)
          v.value_month = v.value_month.toFixed(5)
          if (isNaN(v.valuePerYear)) {
            v.valuePerYear = 0
          }
          if (isNaN(v.value_month)) {
            v.value_month = 0
          }
        }
      })
      return data
    },
    onData() {
      if (this.$refs.editTable) {
        const models = this.$refs.editTable.getData()
        models.forEach((model) => {
          this.setValueToFieldsByCharacteristic(model)
        })
      }
    },
    onFields() {
      if (this.$refs.editTable) {
        const models = this.$refs.editTable.getData()
        models.forEach((model) => {
          this.setValueToRowByCharacteristic(model)
        })
      }
    },
    /**
     * fields -> row
     */
    setValueToRowByCharacteristic(model) {
      if (model.characteristic && model.characteristic.value) {
        const fName = model.characteristic.value
        if (this.fields && this.fields.hasOwnProperty(fName)) {
          if (model.value != this.fields[fName]) {
            model.value = this.fields[fName]
            model.start_used_at = ''
            if (this.$refs.editTable) {
              this.$refs.editTable.openEditMode(model)
            }
          }
        }
      }
    },
    /**
     * row -> fields
     */
    setValueToFieldsByCharacteristic(model) {
      if (model.characteristic && model.characteristic.value) {
        const fName = model.characteristic.value
        if (this.fields[fName] != model.value) {
          this.fields[fName] = model.value
        }
      }
    },
    /**
     * @override
     */
    getTableRef() {
      return this.$refs.editTable
    },
    onSelect(ctx, $event, model) {
      if ($event && $event.id) {
        let copy = Object.assign({}, $event)
        model.normativ_id = copy.id
        model.category = copy.name
        model.unit = copy.unit
        model.valuePerYear = copy.valuePerYear
        model.value_month = copy.valuePerMonth
        model.characteristic = copy.characteristic
        this.setValueToRowByCharacteristic(model)
        model.start_used_at = this.fields.opened_at || ''
      } else {
        model.normativ_id = ''
        model.category = ''
        model.unit = ''
        model.valuePerYear = ''
        model.value_month = ''
        model.characteristic = {}
        model.start_used_at = ''
      }
    },
    suggestionEndpoint(ctx, q) {
      return billing.normativeBranchs(
        {
          query: {
            q,
            end_date: '',
            'per-page': 50,
          },
        },
        this.normativeType
      )
    },
    transformSuggestions(ctx, response) {
      let data = response.data
      let options = []
      for (let i = 0; i < data.length; i++) {
        let name = data[i].name
        if (
          data[i].garbageSourceCategory &&
          data[i].garbageSourceCategory.name
        ) {
          name = data[i].garbageSourceCategory.name
        }
        options.push({
          name,
          characteristic: data[i].characteristic,
          id: data[i].id,
          unit: data[i].unit,
          valuePerYear: data[i].value,
          valuePerMonth: (+data[i].value / 12).toFixed(5),
        })
      }
      return options
    },
    addNewRow() {
      const Model = () => {
        return {
          normativ_id: '',
          value: '',
          unit: '',
          updated_at: '',
          start_used_at: '',
          value_month: '',
          characteristic: {},
        }
      }

      this.$refs.editTable.createRow(new Model())
    },
  },
  mounted() {
    this.attachWatchers()
  },
}
</script>
